import React, {Component} from 'react';
import {APIClient} from "../../../../utils/APIClient";
import {isOk} from "../../../../utils/apiResponse";
import {Loading} from "../../../Loading";
import {LoadErrorState} from "../../../elements/LoadErrorState";
import {FilterableLeadRow} from "./FilterableLeadRow";
import SellLeadModal from "../lead_detail/SellLeadModal";
import { withTranslation } from 'react-i18next';

class LeadsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            amountModalInfo: {
                isOpen: false,
                lead: ''
            },
            leads: null,
            // No se pudieron traer los prospectos. Estado propio, con `null` = sin error y un string
            // (que puede ser '') = con error: sin él, `leads` se queda en `null` y el render deja el
            // <Loading> "Obteniendo prospectos..." para siempre.
            loadError: null
        };

        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleLeadSoldSubmit = this.handleLeadSoldSubmit.bind(this);
        this.fetchLeads = this.fetchLeads.bind(this);
        this.handleRetryLoad = this.handleRetryLoad.bind(this);
    }

    componentDidMount() {
        this.fetchLeads();
    }

    // API

    fetchLeads() {
        new APIClient(`${this.props.crmApiURL}/leads`).call('GET').then((response) => {
            // `status !== 'OK'`, no `=== 'ERROR'`: por ese literal no entran ni el `NETWORK_ERROR`
            // que devuelve el `APIClient` ante un microcorte ni los códigos tipados del backend, y
            // los dos caían en el `else` -la rama de ÉXITO- a morir en `response.data.map(...)`.
            // El endpoint responde con `OKResponse` (`core/views/crm/leads.py`), así que la clave
            // `status` siempre viaja.
            if (!isOk(response)) {
                this.setState({loadError: response.error_message || ''});
            } else {
                const leads = response.data.map((lead) => {
                    return {
                        id: lead.id,
                        submittedOn: lead.submitted_on_display_format,
                        submittedOnFormatted: lead.submitted_on_date_format,
                        firstName: lead.first_name || '',
                        lastName: lead.last_name || '',
                        sellingState: lead.status || '',
                        phoneNumber: lead.phone_number || '',
                        email: lead.email || '',
                        campaign: lead.campaign || '',
                        adgroup: lead.ad_group || '',
                        keyword: lead.keyword || '',
                        message: lead.message || '',
                    }
                });

                this.setState({leads: leads, loadError: null});
            }
        });
    }

    /**
     * Vuelve al <Loading>: `leads: null` es lo que lo dibuja. Sin ese reset la pantalla de error se
     * queda igual hasta que responda el request, así que el click no se ve y el usuario lo repite.
     */
    handleRetryLoad() {
        this.setState({loadError: null, leads: null}, this.fetchLeads);
    }

    submitLeadStateChange(leadId, changeData) {
        let submit_url = `${this.props.crmApiURL}/lead/${leadId}/state`;
        new APIClient(submit_url).call('PUT', changeData).then((response) => {
            if (response.status === 'ERROR') {
                alert(response['error_message']);
            } else if (response.status === 'OK') {
                this.changeStateOfLead(leadId, changeData.state);
            }
        })
    }

    // handlers

    handleStateChange(leadId, state) {
        if (state === 'WON') {
            this.openAmountModal(leadId);
        } else {
            this.submitLeadStateChange(leadId, {'state': state.toUpperCase()});
        }
    }

    handleLeadSoldSubmit(leadId, saleAmount) {
        this.closeAmountModal();
        let changeData = {'state': 'WON'};
        if (saleAmount !== '') {
            changeData['sale_amount'] = saleAmount
        }
        this.submitLeadStateChange(leadId, changeData)
    }

    // helpers

    changeStateOfLead(leadId, leadState) {
        const newLeads = this.state.leads.map(lead => {
            if (lead.id === leadId) {
                return {
                    ...lead,
                    sellingState: leadState
                };
            } else {
                return lead;
            }
        });

        this.setState({leads: newLeads});
    }

    openAmountModal(leadId) {
        this.setState({
            amountModalInfo: {
                isOpen: true,
                leadId: leadId
            }
        });
    }

    closeAmountModal() {
        this.setState({
            amountModalInfo: {
                isOpen: false,
                leadId: ''
            }
        })
    }

    // render

    render() {
        const { t } = this.props;
        if (this.state.loadError !== null) {
            return (
                <LoadErrorState title={t('leads_list.load_error')}
                                text={t('leads_list.load_error_explanation')}
                                retryLabel={t('leads_list.load_error_retry')}
                                onRetry={this.handleRetryLoad}/>
            );
        }

        if (this.state.leads === null) {
            return (
                <Loading message={t('leads_list.fetching_leads')}/>
            );
        }

        if (this.state.leads.length > 0) {
            return (
                <div>
                    {this.renderSellLeadModal()}
                    {this.renderLeadList()}
                </div>
            )
        }
        else {
            return (
                <Loading message={t('leads_list.no_leads_yet')}/>
            );
        }
    }

    renderLeadList() {
        return <ul className="leads-list">
            {this.state.leads.map(lead => {
                    return (
                        <FilterableLeadRow
                            key={lead.id}
                            filterValues={this.props.filterValues}
                            lead={lead}
                            onStateChange={this.handleStateChange}
                            crmFrontPath={this.props.crmFrontPath}
                        />
                    )
                }
            )}
        </ul>;
    }

    renderSellLeadModal() {
        return <SellLeadModal leadId={this.state.amountModalInfo.leadId}
        onSubmit={this.handleLeadSoldSubmit}
        open={this.state.amountModalInfo.isOpen} />;
    }

}

export default withTranslation()(LeadsList);